<div class="toggle-container">
  <span class="toggle-label">{{ 'Enable Push Notifications' | translate }}</span>
  <p-toggleswitch
    [(ngModel)]="arePushNotificationsEnabled"
    (onChange)="toggleNotifications($event.checked)"
  ></p-toggleswitch>
</div>

@if (arePushNotificationsEnabled) {
  <div class="test-notification-container">
    <span class="test-description">{{ 'Verify that notifications reach your device' | translate }}</span>
    <button
      class="test-btn"
      (click)="sendTestNotification()"
      [disabled]="isSendingTest"
    >
      @if (isSendingTest) {
        {{ 'Sending...' | translate }}
      } @else {
        {{ 'Send Test Notification' | translate }}
      }
    </button>
  </div>
}
